import { bbox } from '@turf/turf';
import { LngLatBounds } from 'maplibre-gl';

export const getBounds = (resultPath) => {
  if (resultPath.features.length === 0) {
    return;
  }
  const boundbox = bbox(resultPath);
  const southWest = [boundbox[0], boundbox[1]];
  const northEast = [boundbox[2], boundbox[3]];
  return new LngLatBounds(southWest, northEast);
};

export const getCenterBounds = (bbox) => {
  const southWest = [bbox[0], bbox[1]];
  const northEast = [bbox[2], bbox[3]]; 
  const boundingBox = new LngLatBounds(southWest, northEast);
  const centerLnglat =  boundingBox.getCenter();
  return [centerLnglat.lng, centerLnglat.lat];
};

